// @flow

import { type Address } from './types';

export function getStreetComplement(address: Address): string {
  return address['street_complement'] || '';
}
